import { loadLocaleNs as t } from "../../../i18n/initializer.js";
var n = class {
  loadAppNamespace;
  type = "backend";
  debug = !1;
  constructor(e) {
    this.loadAppNamespace = e;
  }
  init(e, d, i) {
    this.debug = !!i?.debug;
  }
  read(e, d, i) {
    this.debug && console.debug("[i18n-backend] loading", {
      lng: e,
      namespace: d
    }), (this.loadAppNamespace ? this.loadAppNamespace(e, d).then((o) => o === void 0 ? t(e, d) : o) : t(e, d)).then((o) => {
      this.debug && console.debug("[i18n-backend] loaded", {
        lng: e,
        namespace: d
      }), o && typeof o == "object" ? i(null, o) : i(null, void 0);
    }).catch((o) => {
      this.debug && console.error("[i18n-backend] error loading", {
        lng: e,
        namespace: d,
        err: o
      }), i(o instanceof Error ? o : new Error(String(o)), !1);
    });
  }
};
export {
  n as TranslationProviderBackend
};

//# sourceMappingURL=TranslationProvider.backend.js.map